import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function mealVoucherValidator(minimum: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    const isValid = value === 0 || value >= minimum;

    return isValid ? null : { invalidMealVoucher: { value: control.value } };
  };
}